import { createSlice, Slice } from '@reduxjs/toolkit';
import { mapReducers } from './mapReducers';
import { Node } from '@/types';

export type EditorMode = 'none' | 'shift';

export type EditorNode = Partial<Node> & {
  splitEdgeId?: string | number;
  tspId?: string | number;
};

export type Path = {
  nodes: number[];
  color: string;
  id?: string | number;
  options?: {
    dimWhenFiltered?: boolean;
    arrowHeads?: boolean;
  };
  getProperties?: (solid: boolean) => Record<string, any>;
};

export type MapState = {
  editor: {
    mode: EditorMode;
    node: EditorNode | null;
    edgeStartNode: string | number | null;
    edgeEndNode: string | number | null;
    moveNode: string | number | null;
  };
  highlight: {
    tsps: Set<number>;
    zones: Set<number>;
  };
  paths: Path[];
};

const initialState: MapState = {
  editor: {
    mode: 'none',
    node: null,
    edgeStartNode: null,
    edgeEndNode: null,
    moveNode: null,
  },
  highlight: {
    tsps: new Set<number>(),
    zones: new Set<number>(),
  },
  paths: [],
};

export const mapSlice: Slice<MapState, typeof mapReducers, 'map'> = createSlice(
  {
    name: 'map',
    initialState,
    reducers: mapReducers,
  },
);

export const mapActions = mapSlice.actions;

export default mapSlice.reducer;
